export default __webpack_public_path__ + "static/media/icon_instagram.4a65c015.svg";